import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  ViewEncapsulation,
} from "@angular/core";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { Store } from "@ngrx/store";
import { Dictionary } from "src/app/store/models/common_types";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { VAIconRegistryService, close } from "@va/core-library/icons";

@Component({
  selector: "app-watchlist-search-add",
  templateUrl: "./watchlist-search-add.component.html",
  styleUrls: ["./watchlist-search-add.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class WatchlistSearchAddComponent implements OnInit {
  @Input() saveTrigger: number;
  @Input() existingTickers: any;
  @Output() watchListData = new EventEmitter<any>();

  watchlisNameInput = "";
  currentGridTickers: Array<any> = [];
  errorTickerList: Array<any> = [];
  successTickerList: Array<any> = [];
  deleteSelectedTickers = new Set<string>();
  indeterminate = false;
  currentCompanyInfo: Dictionary<any> = {};
  pageName: string;
  currentTicker: string;
  watchlistGridLoading = true;
  checked = false;
  hasErrors = false;
  ngDestroyed$ = new Subject();

  constructor(
    private store: Store<AppState>,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([close]);
  }

  ngOnInit() {
    // this.successTickerList = [];
    // this.errorTickerList = [];
    // this.currentGridTickers = [];
    this.addCurrentTicker();
  }

  // This function adds current ticker to watchlist by default if watchlist is created from company page
  addCurrentTicker() {
    this.store
      .select(stateGetter("globalSubheader"))
      .pipe(takeUntil(this.ngDestroyed$))
      .subscribe((data) => {
        if (data && data.pageName === "company") {
          this.currentTicker = data.ticker.toUpperCase();
          const company = {
            ticker: this.currentTicker,
            name: data.subheaderTitle,
            isSelected: true,
            bbgTicker: "",
            checked: false,
            hasError: false,
            errorMsg: "ok",
            id: `${this.currentTicker}ok`,
          };
          this.currentCompanyInfo = { ...this.currentCompanyInfo, ...company };
          this.successTickerList.unshift(this.currentCompanyInfo);
          this.currentGridTickers = [
            ...this.errorTickerList,
            ...this.successTickerList,
          ];
          this.returnWatchlistData(false);
        } else {
          this.watchlistGridLoading = false;
        }
      });
  }

  ngOnDestroy() {
    this.ngDestroyed$.next();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.existingTickers &&
      this.existingTickers &&
      this.existingTickers.length
    ) {
      this.clearSelection();
      const listWithSelectedFlag = this.existingTickers.map(
        function (tickerInfo) {
          return {
            ticker: tickerInfo.ticker,
            name: tickerInfo.tickerFullName,
            isSelected: true,
            bbgTicker: tickerInfo.bTicker,
            checked: false,
            hasError: tickerInfo.hasError,
            errorMsg: tickerInfo.errorMsg,
            id: tickerInfo.ticker + tickerInfo.errorMsg,
          };
        },
      );
      this.successTickerList = [...listWithSelectedFlag];
      this.errorTickerList = [];
      this.currentGridTickers = [
        ...this.errorTickerList,
        ...this.successTickerList,
      ];
      this.watchlistGridLoading = false;
    } else if (
      changes.saveTrigger &&
      !changes.saveTrigger.firstChange &&
      changes.saveTrigger.currentValue !== changes.saveTrigger.previousValue
    ) {
      this.returnWatchlistData(this.hasErrors);
    }
  }

  returnWatchlistData(onPaste?) {
    // return data of matching tickers
    // Adding a comment to delete later

    if (onPaste) {
      this.watchListData.emit({
        data: this.currentGridTickers,
        context: "validation",
        invalidCount: this.errorTickerList.length,
      });
      this.hasErrors = true;
    } else {
      const listOfTickers = this.currentGridTickers.map((x) => x.ticker);
      this.watchListData.emit({
        data: listOfTickers,
        context: "searchAndAdd",
        invalidCount: this.errorTickerList.length,
      });
    }
  }

  addSearchedTicker(searchResult): void {
    const tickerList = searchResult.success;
    const errorList = searchResult.error;
    if (tickerList.length === 1 && errorList.length === 0) {
      const tickerInfo = tickerList[0];
      const company = {
        ticker: tickerInfo.ticker,
        name: tickerInfo.tickerFullName,
        isSelected: true,
        bbgTicker: tickerInfo.bTicker,
        checked: false,
        hasError: tickerInfo.hasError,
        errorMsg: tickerInfo.errorMsg,
        id: tickerInfo.ticker + tickerInfo.errorMsg,
      };
      const tickerExist = this.successTickerList.filter((data) => {
        return data.ticker === tickerInfo.ticker;
      });
      //EOA : bug fix if searching and adding ticker which exist on LHS , it should get checked
      if (tickerExist.length === 0) {
        this.successTickerList.unshift(company);
        this.currentGridTickers = [
          ...this.errorTickerList,
          ...this.successTickerList,
        ];
        this.returnWatchlistData();
      }
    } else {
      const newSuccessTickers = [];
      tickerList.forEach((tickerInfo) => {
        const isAlreadyPresent = this.successTickerList.findIndex(
          (obj) => obj.ticker === tickerInfo.ticker,
        );
        if (isAlreadyPresent === -1) {
          newSuccessTickers.push({
            ticker: tickerInfo.ticker,
            name: tickerInfo.tickerFullName,
            isSelected: true,
            bbgTicker: tickerInfo.bTicker,
            checked: false,
            hasError: tickerInfo.hasError,
            errorMsg: tickerInfo.errorMsg,
            id: tickerInfo.ticker + tickerInfo.errorMsg,
          });
        }
      });
      this.successTickerList = [
        ...newSuccessTickers,
        ...this.successTickerList,
      ];
      const newErrorTickers = [];
      errorList.forEach((tickerInfo) => {
        const isAlreadyPresent = this.errorTickerList.findIndex(
          (obj) => obj.ticker === tickerInfo.ticker,
        );
        if (isAlreadyPresent === -1) {
          newErrorTickers.push({
            ticker: tickerInfo.ticker,
            name: tickerInfo.tickerFullName,
            isSelected: true,
            bbgTicker: tickerInfo.bTicker,
            checked: false,
            hasError: tickerInfo.hasError,
            errorMsg: tickerInfo.errorMsg,
            id: tickerInfo.ticker + tickerInfo.errorMsg,
          });
        }
      });
      this.errorTickerList = [...newErrorTickers, ...this.errorTickerList];

      this.currentGridTickers = [
        ...this.errorTickerList,
        ...this.successTickerList,
      ];
      this.returnWatchlistData(true);
    }
  }

  removeTicker() {
    const tempSuccessTickers = [...this.successTickerList];
    const tempErrorTickers = [...this.errorTickerList];

    this.deleteSelectedTickers.forEach((id) => {
      //company.isSelected = false;
      let index = tempSuccessTickers.findIndex((val) => {
        return val.id === id;
      });

      if (index >= 0) tempSuccessTickers.splice(index, 1);

      index = tempErrorTickers.findIndex((val) => {
        return val.id === id;
      });

      if (index >= 0) tempErrorTickers.splice(index, 1);

      return id;
    });
    this.errorTickerList = [...tempErrorTickers];
    this.successTickerList = [...tempSuccessTickers];
    this.currentGridTickers = [
      ...this.errorTickerList,
      ...this.successTickerList,
    ];
    this.returnWatchlistData();
    this.refreshCheckedStatus();
    this.clearSelection();
  }

  removeAllTickers() {
    this.successTickerList = [];
    this.errorTickerList = [];
    this.currentGridTickers = [];
    this.returnWatchlistData();
    this.clearSelection();
  }
  onAllChecked(value: boolean): void {
    this.currentGridTickers.forEach((item) =>
      this.updateCheckedSet(item.id, value),
    );
    this.refreshCheckedStatus();
  }
  onItemChecked(id: string, checked: boolean): void {
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();
  }
  updateCheckedSet(id: string, checked: boolean): void {
    if (checked) {
      this.deleteSelectedTickers.add(id);
    } else {
      this.deleteSelectedTickers.delete(id);
    }
  }

  refreshCheckedStatus(): void {
    this.checked = this.currentGridTickers.every((item) =>
      this.deleteSelectedTickers.has(item.id),
    );
    if (this.currentGridTickers.length === 0) {
      this.checked = false;
    }
    this.indeterminate =
      this.currentGridTickers.some((item) =>
        this.deleteSelectedTickers.has(item.id),
      ) && !this.checked;
  }

  clearSelection() {
    // clear selection made in modal, othewise same tickers show up as selected
    // on next trigger
    this.deleteSelectedTickers = new Set<string>();
    this.checked = false;
    this.indeterminate = false;
  }
}
